import { createSlice } from "@reduxjs/toolkit";

const initialGuestsState = {
	listLoading: false,
	actionsLoading: false,
	totalCount: 0,
	entities: null,
	guestForEdit: undefined,
	lastError: null,
};
export const callTypes = {
	list: "list",
	action: "action",
};

export const guestsSlice = createSlice({
	name: "guests",
	initialState: initialGuestsState,
	reducers: {
		catchError: (state, action) => {
			state.error = `${action.type}: ${action.payload.error}`;
			if (action.payload.callType === callTypes.list) {
				state.listLoading = false;
			} else {
				state.actionsLoading = false;
			}
		},
		startCall: (state, action) => {
			state.error = null;
			if (action.payload.callType === callTypes.list) {
				state.listLoading = true;
			} else {
				state.actionsLoading = true;
			}
		},
		// getguestById
		guestFetched: (state, action) => {
			state.actionsLoading = false;
			state.guestForEdit = action.payload.guestForEdit;
			state.error = null;
		},
		// findguests
		guestsFetched: (state, action) => {
			const { totalCount, entities } = action.payload;
			state.listLoading = false;
			state.error = null;
			state.entities = entities;
			state.totalCount = totalCount;
		},
		// createguest
		guestCreated: (state, action) => {
			state.ewactionsLoading = false;
			state.error = null;
			state.entities.push(action.payload.guest);
		},
		// updateguest
		guestUpdated: (state, action) => {
			state.error = null;
			state.actionsLoading = false;
			state.entities = state.entities.map((entity) => {
				if (entity.id === action.payload.guest.id) {
					return action.payload.guest;
				}
				return entity;
			});
		},
		// deleteguest
		guestDeleted: (state, action) => {
			state.error = null;
			state.actionsLoading = false;
			state.entities = state.entities.filter(
				(el) => el.id !== action.payload.id
			);
		},
		// deleteguests
		guestsDeleted: (state, action) => {
			state.error = null;
			state.actionsLoading = false;
			state.entities = state.entities.filter(
				(el) => !action.payload.ids.includes(el.id)
			);
		},
		// guestsUpdateState
		guestsStatusUpdated: (state, action) => {
			state.actionsLoading = false;
			state.error = null;
			const { ids, status } = action.payload;
			state.entities = state.entities.map((entity) => {
				if (ids.findIndex((id) => id === entity.id) > -1) {
					entity.status = status;
				}
				return entity;
			});
		},
	},
});
